import { render, staticRenderFns } from "./preferenciasNotificaciones.vue?vue&type=template&id=5e788b6a&scoped=true&"
import script from "./preferenciasNotificaciones.vue?vue&type=script&lang=js&"
export * from "./preferenciasNotificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e788b6a",
  null
  
)

export default component.exports